export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot password?',
  'pages.login.forgotPassword.title': 'Forgot password',
  'pages.login.forgotPassword.fetchMasked': 'Get masked email',
  'pages.login.forgotPassword.maskedLabel': 'Masked email',
  'pages.login.forgotPassword.maskedLoaded': 'Masked email loaded',
  'pages.login.forgotPassword.email': 'Email',
  'pages.login.forgotPassword.emailPlaceholder': 'Enter your full email',
  'pages.login.forgotPassword.emailRequired': 'Please enter your email',
  'pages.login.forgotPassword.emailInvalid': 'Invalid email format',
  'pages.login.forgotPassword.verifyEmail': 'Verify email',
  'pages.login.forgotPassword.verifyOk': 'Email verified',
  'pages.login.forgotPassword.verifyFail': 'Username and email do not match',
  'pages.login.forgotPassword.verifyFirst': 'Please verify your email first',
  'pages.login.forgotPassword.sendCode': 'Send code',
  'pages.login.forgotPassword.resendIn': 'Resend in {seconds}s',
  'pages.login.forgotPassword.sendOk': 'Verification code sent',
  'pages.login.forgotPassword.sendFail': 'Failed to send verification code',
  'pages.login.forgotPassword.code': 'Verification code',
  'pages.login.forgotPassword.codePlaceholder': 'Enter the code from email',
  'pages.login.forgotPassword.codeRequired': 'Please enter the verification code',
  'pages.login.forgotPassword.newPassword': 'New password',
  'pages.login.forgotPassword.newPasswordRequired': 'Please enter a new password',
  'pages.login.forgotPassword.passwordMin': 'At least 6 characters',
  'pages.login.forgotPassword.confirmPassword': 'Confirm new password',
  'pages.login.forgotPassword.confirmRequired': 'Please confirm your new password',
  'pages.login.forgotPassword.passwordMismatch': 'The two passwords do not match',
  'pages.login.forgotPassword.submit': 'Reset password',
  'pages.login.forgotPassword.resetOk': 'Password reset successful. Please sign in with your new password.',
  'pages.login.forgotPassword.resetFail': 'Failed to reset password',
  'pages.login.forgotPassword.requestFailed': 'Request failed. Please try again.',
  'pages.login.forgotPassword.usernameRequired': 'Please enter your username',
  'pages.login.forgotPassword.stepAccount': 'Account',
  'pages.login.forgotPassword.stepEmail': 'Email',
  'pages.login.forgotPassword.stepCode': 'Verification',
  'pages.login.forgotPassword.stepPassword': 'New password',
  'pages.login.forgotPassword.stepAccountDesc': 'Enter your login username. A masked email will be shown for you to verify.',
  'pages.login.forgotPassword.stepEmailDesc': 'Enter the full email address linked to this account.',
  'pages.login.forgotPassword.stepCodeDesc': 'Send a code to your email and enter it below.',
  'pages.login.forgotPassword.stepPasswordDesc': 'Choose a new password for signing in.',
  'pages.login.forgotPassword.contentTitle.step1': 'Recover your password',
  'pages.login.forgotPassword.contentTitle.step2': 'Verify security email',
  'pages.login.forgotPassword.contentTitle.step3': 'Enter verification code',
  'pages.login.forgotPassword.contentTitle.step4': 'Set new password',
  'pages.login.forgotPassword.codeSentTo': 'A code was sent to {email}',
  'pages.login.forgotPassword.next': 'Next',
  'pages.login.forgotPassword.prev': 'Back',
  'pages.login.forgotPassword.finish': 'Reset password',
  'pages.login.forgotPassword.sendCodeFirst': 'Please send the verification code first',
  'pages.login.forgotPassword.codeSentHint': 'Email sent. Please check your inbox.',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.login.brandTitle': 'Aspire.Build. Connect.',
  'pages.login.brandSubtitle': 'Professional Property Management Solution',
  'pages.login.welcomeTitle': 'Welcome Back',
  'pages.login.welcomeSubtitle': 'Please log in to your account to continue',
  'pages.login.username.label': 'Username',
  'pages.login.password.label': 'Password',
  'pages.login.recaptcha.required': 'Please complete the verification',
  'pages.login.recaptcha.error': 'Verification code failed to load, please refresh the page and try again',
  'pages.login.failure.message': 'Login failed, please check your username and password',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',

  // Banner Management Page
  'pages.banner.title': 'Banner Management',
  'pages.banner.create': 'Create Banner',
  'pages.banner.refreshCache': 'Refresh Cache',
  'pages.banner.batchDelete': 'Batch Delete',
  'pages.banner.confirmDelete': 'Are you sure you want to delete this banner?',
  'pages.banner.confirmRefreshCache': 'Are you sure you want to refresh the banner cache?',
  'pages.banner.confirmBatchDelete': 'Are you sure you want to delete the selected {count} banners?',
  'pages.banner.deleteSuccess': 'Banner deleted successfully',
  'pages.banner.batchDeleteSuccess': 'Banners deleted successfully',
  'pages.banner.refreshCacheSuccess': 'Banner cache refreshed successfully',
  'pages.banner.getDetailFailed': 'Failed to get banner details',
  'pages.banner.deleteFailed': 'Failed to delete banner',
  'pages.banner.batchDeleteFailed': 'Failed to delete banners',
  'pages.banner.refreshCacheFailed': 'Failed to refresh banner cache',
  'pages.banner.selectItemsWarning': 'Please select banners to delete',
  'pages.banner.columns.index': 'Index',
  'pages.banner.columns.image': 'Image',
  'pages.banner.columns.title': 'Title',
  'pages.banner.columns.type': 'Type',
  'pages.banner.columns.linkTarget': 'Link Target',
  'pages.banner.columns.sort': 'Sort',
  'pages.banner.columns.status': 'Status',
  'pages.banner.columns.platform': 'Platform',
  'pages.banner.columns.startTime': 'Start Time',
  'pages.banner.columns.endTime': 'End Time',
  'pages.banner.columns.operations': 'Operations',
  'pages.banner.actions.view': 'View',
  'pages.banner.actions.edit': 'Edit',
  'pages.banner.actions.delete': 'Delete',
  'pages.banner.status.online': 'Online',
  'pages.banner.status.offline': 'Offline',
  'pages.banner.linkType.none': 'No Link',
  'pages.banner.linkType.external': 'External Link',
  'pages.banner.linkType.internal': 'Internal Page',
  'pages.banner.linkType.product': 'Product Detail',
  'pages.banner.platform.all': 'All',
  'pages.banner.platform.ios': 'iOS',
  'pages.banner.platform.android': 'Android',
  'pages.banner.platform.h5': 'H5',
  'pages.banner.detail.title': 'Banner Details',
  'pages.banner.detail.basicInfo': 'Basic Information',
  'pages.banner.detail.timeInfo': 'Time Information',
  'pages.banner.detail.remarks': 'Remarks',
  'pages.banner.detail.createTime': 'Create Time',
  'pages.banner.detail.updateTime': 'Update Time',

  // Banner Form
  'pages.banner.form.editTitle': 'Edit Banner',
  'pages.banner.form.createTitle': 'Create Banner',
  'pages.banner.form.titleLabel': 'Banner Title',
  'pages.banner.form.titlePlaceholder': 'Please enter banner title',
  'pages.banner.form.titleRequired': 'Please enter banner title',
  'pages.banner.form.titleMaxLength': 'Title cannot exceed 100 characters',
  'pages.banner.form.imageLabel': 'Banner Image',
  'pages.banner.form.imageRequired': 'Please upload banner image',
  'pages.banner.form.uploadTab': 'Local Upload',
  'pages.banner.form.urlTab': 'Image URL',
  'pages.banner.form.uploadImageTypeError': 'Only image files can be uploaded!',
  'pages.banner.form.uploadImageSizeError': 'Image size cannot exceed 5MB!',
  'pages.banner.form.uploadSuccess': 'Image uploaded successfully',
  'pages.banner.form.uploadFailed': 'Image upload failed',
  'pages.banner.form.updateSuccess': 'Banner updated successfully',
  'pages.banner.form.createSuccess': 'Banner created successfully',
  'pages.banner.form.updateFailed': 'Failed to update banner',
  'pages.banner.form.createFailed': 'Failed to create banner',
  'pages.banner.form.urlPlaceholder': 'Please enter image URL',
  'pages.banner.form.uploadHint': 'Click or drag image here to replace',
  'pages.banner.form.uploading': 'Uploading...',
  'pages.banner.form.uploadPrompt': 'Drag or click to upload',
  'pages.banner.form.uploadFormatHint': 'Supports JPG/PNG/GIF/WEBP formats, max 2MB',
  'pages.banner.form.imageSizeRecommend': 'Recommended size: 750x300 pixels. Image will be displayed as full URL but only relative path is stored in database',
  'pages.banner.form.linkTypeLabel': 'Link Type',
  'pages.banner.form.linkTypeRequired': 'Please select link type',
  'pages.banner.form.linkTargetLabel': 'Link Target',
  'pages.banner.form.linkTargetPlaceholder': 'Please enter link, route or ID',
  'pages.banner.form.sortOrderLabel': 'Sort Order',
  'pages.banner.form.sortOrderPlaceholder': 'Please enter sort order',
  'pages.banner.form.sortOrderHelp': 'Smaller values appear first, automatically gets next available value when creating new',
  'pages.banner.form.statusLabel': 'Status',
  'pages.banner.form.statusRequired': 'Please select status',
  'pages.banner.form.platformLabel': 'Platform',
  'pages.banner.form.platformRequired': 'Please select platform',
  'pages.banner.form.remarksLabel': 'Remarks',
  'pages.banner.form.remarksPlaceholder': 'Please enter remarks',

  // Announcement Management Page
  'pages.announcement.title': 'Announcement Management',
  'pages.announcement.create': 'Create Announcement',
  'pages.announcement.batchDelete': 'Batch Delete',
  'pages.announcement.confirmDelete': 'Are you sure you want to delete this announcement?',
  'pages.announcement.confirmBatchDelete': 'Are you sure you want to delete the selected {count} announcements?',
  'pages.announcement.deleteSuccess': 'Announcement deleted successfully',
  'pages.announcement.batchDeleteSuccess': 'Successfully deleted {count} announcements',
  'pages.announcement.deleteFailed': 'Failed to delete announcement',
  'pages.announcement.batchDeleteFailed': 'Failed to delete announcements',
  'pages.announcement.getListFailed': 'Failed to get announcement list',
  'pages.announcement.columns.image': 'Image',
  'pages.announcement.columns.title': 'Announcement Title',
  'pages.announcement.columns.type': 'Announcement Type',
  'pages.announcement.columns.status': 'Status',
  'pages.announcement.columns.startTime': 'Start Time',
  'pages.announcement.columns.endTime': 'End Time',
  'pages.announcement.columns.createTime': 'Create Time',
  'pages.announcement.columns.operations': 'Operations',
  'pages.announcement.actions.view': 'View',
  'pages.announcement.actions.edit': 'Edit',
  'pages.announcement.actions.delete': 'Delete',
  'pages.announcement.status.enabled': 'Enabled',
  'pages.announcement.status.disabled': 'Disabled',
  'pages.announcement.status.unknown': 'Unknown',
  'pages.announcement.type.system': 'System Announcement',
  'pages.announcement.type.activity': 'Activity Announcement',
  'pages.announcement.type.maintenance': 'Maintenance Announcement',
  'pages.announcement.type.other': 'Other',
  'pages.announcement.type.unknown': 'Unknown',
  'pages.announcement.tag.pinned': 'Pinned',
  'pages.announcement.tag.urgent': 'Urgent',
  'pages.announcement.language.chinese': 'Chinese',
  'pages.announcement.language.english': 'English',
  'pages.announcement.detail.title': 'Announcement Details',
  'pages.announcement.detail.basicInfo': 'Basic Information',
  'pages.announcement.detail.timeInfo': 'Time Information',
  'pages.announcement.detail.attachments': 'Attachments',
  'pages.announcement.detail.content': 'Announcement Content',
  'pages.announcement.preview.title': 'Announcement Preview',

  // Announcement Form
  'pages.announcement.form.editTitle': 'Edit {type}',
  'pages.announcement.form.createTitle': 'Create {type}',
  'pages.announcement.form.systemAnnouncement': 'System Announcement',
  'pages.announcement.form.urgentNotice': 'Urgent Notice',
  'pages.announcement.form.titleLabel': 'Announcement Title',
  'pages.announcement.form.titlePlaceholder': 'Please enter announcement title',
  'pages.announcement.form.titleRequired': 'Please enter announcement title',
  'pages.announcement.form.titleMaxLength': 'Title cannot exceed 100 characters',
  'pages.announcement.form.typeLabel': 'Announcement Type',
  'pages.announcement.form.typeRequired': 'Please select announcement type',
  'pages.announcement.form.statusLabel': 'Is Enabled',
  'pages.announcement.form.statusRequired': 'Please select whether to enable',
  'pages.announcement.form.startTimeLabel': 'Effective Time',
  'pages.announcement.form.startTimeRequired': 'Please select effective time',
  'pages.announcement.form.endTimeLabel': 'Expiration Time',
  'pages.announcement.form.endTimeRequired': 'Please select expiration time',
  'pages.announcement.form.endTimeValidation': 'Expiration time must be later than effective time',
  'pages.announcement.form.pinnedLabel': 'Is Pinned',
  'pages.announcement.form.attachmentsLabel': 'Attachment Upload',
  'pages.announcement.form.attachmentsHelp': 'Recommended size: 750x300 pixels, supports multiple image uploads',
  'pages.announcement.form.attachmentsTypeError': 'Only image files can be uploaded!',
  'pages.announcement.form.attachmentsSizeError': 'Image size cannot exceed 5MB!',
  'pages.announcement.form.attachmentsUploadSuccess': '{fileName} uploaded successfully',
  'pages.announcement.form.attachmentsUploadFailed': '{fileName} upload failed',
  'pages.announcement.form.attachmentsUploadedCount': '{count} images uploaded, click or drag to add more',
  'pages.announcement.form.attachmentsUploadPrompt': 'Click or drag images here to upload',
  'pages.announcement.form.attachmentsFormatHint': 'Supports JPG/PNG/GIF/WEBP formats, max 5MB, multiple images allowed',
  'pages.announcement.form.contentLabel': 'Announcement Content',
  'pages.announcement.form.contentRequired': 'Please enter announcement content',
  'pages.announcement.form.updateSuccess': 'Announcement updated successfully',
  'pages.announcement.form.createSuccess': 'Announcement created successfully',
  'pages.announcement.form.submitFailed': 'Failed to submit announcement',

  // Urgent Notice Management Page
  'pages.urgent.title': 'Urgent Notice Management',
  'pages.urgent.create': 'Create Urgent Notice',
  'pages.urgent.batchDelete': 'Batch Delete',
  'pages.urgent.confirmDelete': 'Are you sure you want to delete this urgent notice?',
  'pages.urgent.confirmBatchDelete': 'Are you sure you want to delete the selected {count} urgent notices?',
  'pages.urgent.deleteSuccess': 'Urgent notice deleted successfully',
  'pages.urgent.batchDeleteSuccess': 'Successfully deleted {count} urgent notices',
  'pages.urgent.deleteFailed': 'Failed to delete urgent notice',
  'pages.urgent.batchDeleteFailed': 'Failed to delete urgent notices',
  'pages.urgent.getListFailed': 'Failed to get urgent notice list',
  'pages.urgent.columns.image': 'Image',
  'pages.urgent.columns.title': 'Notice Title',
  'pages.urgent.columns.type': 'Notice Type',
  'pages.urgent.columns.status': 'Status',
  'pages.urgent.columns.startTime': 'Start Time',
  'pages.urgent.columns.endTime': 'End Time',
  'pages.urgent.columns.createTime': 'Create Time',
  'pages.urgent.columns.operations': 'Operations',
  'pages.urgent.actions.view': 'View',
  'pages.urgent.actions.edit': 'Edit',
  'pages.urgent.actions.delete': 'Delete',
  'pages.urgent.status.enabled': 'Enabled',
  'pages.urgent.status.disabled': 'Disabled',
  'pages.urgent.status.unknown': 'Unknown',
  'pages.urgent.language.chinese': 'Chinese',
  'pages.urgent.language.english': 'English',
  'pages.urgent.detail.title': 'Urgent Notice Details',
  'pages.urgent.detail.basicInfo': 'Basic Information',
  'pages.urgent.detail.timeInfo': 'Time Information',
  'pages.urgent.detail.attachments': 'Attachments',
  'pages.urgent.detail.content': 'Notice Content',
  'pages.urgent.preview.title': 'Urgent Notice Preview',

  // Urgent Notice Form
  'pages.urgent.form.editTitle': 'Edit Urgent Notice',
  'pages.urgent.form.createTitle': 'Create Urgent Notice',
  'pages.urgent.form.titleLabel': 'Notice Title',
  'pages.urgent.form.titlePlaceholder': 'Please enter notice title',
  'pages.urgent.form.titleRequired': 'Please enter notice title',
  'pages.urgent.form.titleMaxLength': 'Title cannot exceed 100 characters',
  'pages.urgent.form.typeLabel': 'Notice Type',
  'pages.urgent.form.typeRequired': 'Please select notice type',
  'pages.urgent.form.statusLabel': 'Is Enabled',
  'pages.urgent.form.statusRequired': 'Please select whether to enable',
  'pages.urgent.form.startTimeLabel': 'Effective Time',
  'pages.urgent.form.startTimeRequired': 'Please select effective time',
  'pages.urgent.form.endTimeLabel': 'Expiration Time',
  'pages.urgent.form.endTimeRequired': 'Please select expiration time',
  'pages.urgent.form.endTimeValidation': 'Expiration time must be later than effective time',
  'pages.urgent.form.pinnedLabel': 'Is Pinned',
  'pages.urgent.form.attachmentsLabel': 'Attachment Upload',
  'pages.urgent.form.attachmentsHelp': 'Recommended size: 750x300 pixels, supports multiple image uploads',
  'pages.urgent.form.attachmentsTypeError': 'Only image files can be uploaded!',
  'pages.urgent.form.attachmentsSizeError': 'Image size cannot exceed 5MB!',
  'pages.urgent.form.attachmentsUploadSuccess': '{fileName} uploaded successfully',
  'pages.urgent.form.attachmentsUploadFailed': '{fileName} upload failed',
  'pages.urgent.form.attachmentsUploadedCount': '{count} images uploaded, click or drag to add more',
  'pages.urgent.form.attachmentsUploadPrompt': 'Click or drag images here to upload',
  'pages.urgent.form.attachmentsFormatHint': 'Supports JPG/PNG/GIF/WEBP formats, max 5MB, multiple images allowed',
  'pages.urgent.form.contentLabel': 'Notice Content',
  'pages.urgent.form.contentRequired': 'Please enter notice content',
  'pages.urgent.form.updateSuccess': 'Urgent notice updated successfully',
  'pages.urgent.form.createSuccess': 'Urgent notice created successfully',
  'pages.urgent.form.submitFailed': 'Failed to submit urgent notice',

  // Community Announcement Management Page
  'pages.community.title': 'Community Announcement Management',
  'pages.community.create': 'Create Community Announcement',
  'pages.community.batchDelete': 'Batch Delete',
  'pages.community.confirmDelete': 'Are you sure you want to delete this community announcement?',
  'pages.community.confirmBatchDelete': 'Are you sure you want to delete the selected {count} community announcements?',
  'pages.community.deleteSuccess': 'Community announcement deleted successfully',
  'pages.community.batchDeleteSuccess': 'Successfully deleted {count} community announcements',
  'pages.community.deleteFailed': 'Failed to delete community announcement',
  'pages.community.batchDeleteFailed': 'Failed to delete community announcements',
  'pages.community.getListFailed': 'Failed to get community announcement list',
  'pages.community.columns.image': 'Image',
  'pages.community.columns.title': 'Announcement Title',
  'pages.community.columns.type': 'Announcement Type',
  'pages.community.columns.status': 'Status',
  'pages.community.columns.startTime': 'Start Time',
  'pages.community.columns.endTime': 'End Time',
  'pages.community.columns.createTime': 'Create Time',
  'pages.community.columns.operations': 'Operations',
  'pages.community.actions.view': 'View',
  'pages.community.actions.edit': 'Edit',
  'pages.community.actions.delete': 'Delete',
  'pages.community.status.enabled': 'Enabled',
  'pages.community.status.disabled': 'Disabled',
  'pages.community.status.unknown': 'Unknown',
  'pages.community.language.chinese': 'Chinese',
  'pages.community.language.english': 'English',
  'pages.community.detail.title': 'Community Announcement Details',
  'pages.community.detail.basicInfo': 'Basic Information',
  'pages.community.detail.timeInfo': 'Time Information',
  'pages.community.detail.attachments': 'Attachments',
  'pages.community.detail.content': 'Announcement Content',
  'pages.community.preview.title': 'Community Announcement Preview',

  // Community Announcement Form
  'pages.community.form.editTitle': 'Edit Community Announcement',
  'pages.community.form.createTitle': 'Create Community Announcement',
  'pages.community.form.titleLabel': 'Announcement Title',
  'pages.community.form.titlePlaceholder': 'Please enter announcement title',
  'pages.community.form.titleRequired': 'Please enter announcement title',
  'pages.community.form.titleMaxLength': 'Title cannot exceed 100 characters',
  'pages.community.form.typeLabel': 'Announcement Type',
  'pages.community.form.typeRequired': 'Please select announcement type',
  'pages.community.form.statusLabel': 'Is Enabled',
  'pages.community.form.statusRequired': 'Please select whether to enable',
  'pages.community.form.startTimeLabel': 'Effective Time',
  'pages.community.form.startTimeRequired': 'Please select effective time',
  'pages.community.form.endTimeLabel': 'Expiration Time',
  'pages.community.form.endTimeRequired': 'Please select expiration time',
  'pages.community.form.endTimeValidation': 'Expiration time must be later than effective time',
  'pages.community.form.contentLabel': 'Announcement Content',
  'pages.community.form.contentRequired': 'Please enter announcement content',
  'pages.community.form.pinnedLabel': 'Is Pinned',
  'pages.community.form.attachmentsLabel': 'Attachment Upload',
  'pages.community.form.attachmentsHelp': 'Recommended size: 750x300 pixels, supports multiple image uploads',
  'pages.community.form.attachmentsTypeError': 'Only image files can be uploaded!',
  'pages.community.form.attachmentsSizeError': 'Image size cannot exceed 5MB!',
  'pages.community.form.attachmentsUploadSuccess': '{fileName} uploaded successfully',
  'pages.community.form.attachmentsUploadFailed': '{fileName} upload failed',
  'pages.community.form.attachmentsUploadedCount': '{count} images uploaded, click or drag to add more',
  'pages.community.form.attachmentsUploadPrompt': 'Click or drag images here to upload',
  'pages.community.form.attachmentsFormatHint': 'Supports JPG/PNG/GIF/WEBP formats, max 5MB, multiple images allowed',
  'pages.community.form.updateSuccess': 'Community announcement updated successfully',
  'pages.community.form.createSuccess': 'Community announcement created successfully',
  'pages.community.form.submitFailed': 'Failed to submit community announcement',
  'pages.community.form.submitData': 'Submitting community announcement data:',

  // Hall Rental Management Page
  'pages.hall.title': 'Hall Rental Management',
  'pages.hall.create': 'Create Hall Rental',
  'pages.hall.batchDelete': 'Batch Delete',
  'pages.hall.confirmDelete': 'Are you sure you want to delete this hall rental?',
  'pages.hall.confirmBatchDelete': 'Are you sure you want to delete the selected {count} hall rentals?',
  'pages.hall.deleteSuccess': 'Hall rental deleted successfully',
  'pages.hall.batchDeleteSuccess': 'Batch delete hall rentals successfully',
  'pages.hall.deleteFailed': 'Failed to delete hall rental',
  'pages.hall.batchDeleteFailed': 'Failed to batch delete hall rentals',
  'pages.hall.getListFailed': 'Failed to get hall rental list',
  'pages.hall.refreshCacheSuccess': 'Cache refreshed successfully',
  'pages.hall.refreshCacheFailed': 'Failed to refresh cache',
  'pages.hall.getDetailFailed': 'Failed to get hall rental details',
  'pages.hall.selectDeleteWarning': 'Please select hall rentals to delete',
  'pages.hall.confirmRefreshCache': 'Are you sure you want to refresh hall rental cache?',
  'pages.hall.refreshCacheDescription': 'After refreshing, all hall rental data will be reloaded',
  'pages.hall.refreshCacheButton': 'Refresh Cache',
  'pages.hall.columns.name': 'Hall Name',
  'pages.hall.columns.title': 'Title',
  'pages.hall.columns.carouselImages': 'Carousel Preview',
  'pages.hall.columns.status': 'Status',
  'pages.hall.columns.sort': 'Sort',
  'pages.hall.columns.operations': 'Operations',
  'pages.hall.actions.view': 'View',
  'pages.hall.actions.edit': 'Edit',
  'pages.hall.actions.delete': 'Delete',
  'pages.hall.status.enabled': 'Enabled',
  'pages.hall.status.disabled': 'Disabled',
  'pages.hall.detail.title': 'Hall Rental Details',
  'pages.hall.detail.basicInfo': 'Basic Information',
  'pages.hall.detail.carouselImages': 'Carousel Images',
  'pages.hall.language.chinese': 'Chinese',
  'pages.hall.language.english': 'English',

  // Hall Rental Form
  'pages.hall.form.editTitle': 'Edit Hall Rental',
  'pages.hall.form.createTitle': 'Create Hall Rental',
  'pages.hall.form.nameLabel': 'Hall Name',
  'pages.hall.form.namePlaceholder': 'Please enter hall name',
  'pages.hall.form.nameRequired': 'Please enter hall name',
  'pages.hall.form.nameMaxLength': 'Name cannot exceed 100 characters',
  'pages.hall.form.carouselImagesLabel': 'Carousel Images',
  'pages.hall.form.carouselImagesUploadButton': 'Upload Image',
  'pages.hall.form.carouselImagesUploading': 'Uploading',
  'pages.hall.form.carouselImagesImageError': 'Only image files can be uploaded!',
  'pages.hall.form.carouselImagesSizeError': 'Image size cannot exceed 5MB!',
  'pages.hall.form.carouselImagesUploadSuccess': 'Image uploaded successfully',
  'pages.hall.form.carouselImagesUploadFailed': 'Image upload failed',
  'pages.hall.form.carouselImagesUploadedCount': '{count} images uploaded',
  'pages.hall.form.carouselImagesImageIndex': 'Image {index}',
  'pages.hall.form.statusLabel': 'Status',
  'pages.hall.form.statusRequired': 'Please select status',
  'pages.hall.form.sortLabel': 'Sort Value',
  'pages.hall.form.sortPlaceholder': 'Please enter sort value',
  'pages.hall.form.titleLabel': 'Title',
  'pages.hall.form.titlePlaceholder': 'Please enter title',
  'pages.hall.form.titleRequired': 'Please enter title',
  'pages.hall.form.titleMaxLength': 'Title cannot exceed 200 characters',
  'pages.hall.form.descriptionLabel': 'Description',
  'pages.hall.form.descriptionPlaceholder': 'Please enter description',
  'pages.hall.form.descriptionMaxLength': 'Description cannot exceed 1000 characters',
  'pages.hall.form.updateSuccess': 'Hall rental updated successfully',
  'pages.hall.form.createSuccess': 'Hall rental created successfully',
  'pages.hall.form.submitFailed': 'Operation failed',

  // Document Management Page
  'pages.document.title': 'Document Management',
  'pages.document.pageSubTitlePublicNote': 'Documents on this page are visible to all users.',
  'pages.document.create': 'Create Document',
  'pages.document.batchDelete': 'Batch Delete',
  'pages.document.confirmDelete': 'Are you sure you want to delete this document?',
  'pages.document.confirmBatchDelete': 'Are you sure you want to delete the selected {count} documents?',
  'pages.document.deleteSuccess': 'Document deleted successfully',
  'pages.document.batchDeleteSuccess': 'Batch delete documents successfully',
  'pages.document.deleteFailed': 'Failed to delete document',
  'pages.document.batchDeleteFailed': 'Failed to batch delete documents',
  'pages.document.getListFailed': 'Failed to get document list',
  'pages.document.getDetailFailed': 'Failed to get document details',
  'pages.document.getMarksFailed': 'Failed to get document marks',
  'pages.document.selectDeleteWarning': 'Please select documents to delete',
  'pages.document.columns.name': 'Document Name',
  'pages.document.columns.category': 'Category',
  'pages.document.columns.docType': 'Document Type',
  'pages.document.columns.mark': 'Document Category',
  'pages.document.columns.fileSize': 'File Size',
  'pages.document.columns.status': 'Status',
  'pages.document.columns.description': 'Description',
  'pages.document.columns.createdTime': 'Created Time',
  'pages.document.columns.operations': 'Operations',
  'pages.document.actions.view': 'View',
  'pages.document.actions.edit': 'Edit',
  'pages.document.actions.delete': 'Delete',
  'pages.document.category.normal': 'Normal Document',
  'pages.document.category.contract': 'Contract Document',
  'pages.document.category.unknown': 'Unknown',
  'pages.document.status.enabled': 'Enabled',
  'pages.document.status.disabled': 'Disabled',
  'pages.document.detail.title': 'Document Details',
  'pages.document.detail.basicInfo': 'Basic Information',
  'pages.document.detail.fileInfo': 'File Information',
  'pages.document.detail.timeInfo': 'Time Information',
  'pages.document.detail.downloadFile': 'Download File',
  'pages.document.language.chinese': 'Chinese',
  'pages.document.language.english': 'English',

  // Document Form
  'pages.document.form.editTitle': 'Edit Document',
  'pages.document.form.createTitle': 'Create Document',
  'pages.document.form.documentInfo': 'Document Information',
  'pages.document.form.basicInfo': 'Basic Information',
  'pages.document.form.fileUpload': 'File Upload',
  'pages.document.form.docNameLabel': 'Title',
  'pages.document.form.docNamePlaceholder': 'Please enter title',
  'pages.document.form.docNameRequired': 'Please enter title',
  'pages.document.form.docNameMaxLength': 'Title cannot exceed 200 characters',
  'pages.document.form.descriptionLabel': 'Description',
  'pages.document.form.descriptionPlaceholder': 'Please enter description',
  'pages.document.form.descriptionMaxLength': 'Description cannot exceed 500 characters',
  'pages.document.form.docTypeLabel': 'File Type',
  'pages.document.form.docTypePlaceholder': 'Please select file type',
  'pages.document.form.docTypeRequired': 'Please select file type',
  'pages.document.form.markLabel': 'Document Category',
  'pages.document.form.markPlaceholder': 'Please select document category',
  'pages.document.form.markRequired': 'Please select document category',
  'pages.document.form.statusLabel': 'Status',
  'pages.document.form.statusPlaceholder': 'Please select status',
  'pages.document.form.statusRequired': 'Please select status',
  'pages.document.form.statusEnabled': 'Enabled',
  'pages.document.form.statusDisabled': 'Disabled',
  'pages.document.form.uploadButton': 'Click to upload file',
  'pages.document.form.uploading': 'Uploading',
  'pages.document.form.uploadFileError': 'Only PDF, Word, Excel, PPT or TXT files can be uploaded!',
  'pages.document.form.uploadSizeError': 'File size cannot exceed 10MB!',
  'pages.document.form.uploadSuccess': 'File uploaded successfully',
  'pages.document.form.uploadFailed': 'File upload failed',
  'pages.document.form.uploadRequired': 'Please upload file',
  'pages.document.form.fileNameLabel': 'File Name: ',
  'pages.document.form.fileSizeLabel': 'File Size: ',
  'pages.document.form.fileTypeLabel': 'File Extension: ',
  'pages.document.form.downloadOriginal': 'Download Original File',
  'pages.document.form.updateSuccess': 'Document updated successfully',
  'pages.document.form.createSuccess': 'Document created successfully',
  'pages.document.form.submitFailed': 'Operation failed',

  // Contract Management Page
  'pages.contract.title': 'Contract Document Management',
  'pages.contract.create': 'Create Contract Document',
  'pages.contract.batchDelete': 'Batch Delete',
  'pages.contract.confirmDelete': 'Are you sure you want to delete this contract document?',
  'pages.contract.confirmBatchDelete': 'Are you sure you want to delete the selected {count} contract documents?',
  'pages.contract.deleteSuccess': 'Contract document deleted successfully',
  'pages.contract.batchDeleteSuccess': 'Batch delete contract documents successfully',
  'pages.contract.deleteFailed': 'Failed to delete contract document',
  'pages.contract.batchDeleteFailed': 'Failed to batch delete contract documents',
  'pages.contract.getListFailed': 'Failed to get contract document list',
  'pages.contract.getDetailFailed': 'Failed to get contract document details',
  'pages.contract.selectDeleteWarning': 'Please select contract documents to delete',
  'pages.contract.columns.name': 'Contract Name',
  'pages.contract.columns.category': 'Category',
  'pages.contract.columns.docType': 'Document Type',
  'pages.contract.columns.fileSize': 'File Size',
  'pages.contract.columns.status': 'Status',
  'pages.contract.columns.description': 'Description',
  'pages.contract.columns.createdTime': 'Created Time',
  'pages.contract.columns.operations': 'Operations',
  'pages.contract.actions.view': 'View',
  'pages.contract.actions.edit': 'Edit',
  'pages.contract.actions.delete': 'Delete',
  'pages.contract.category.normal': 'Normal Document',
  'pages.contract.category.contract': 'Contract Document',
  'pages.contract.category.unknown': 'Unknown',
  'pages.contract.status.enabled': 'Enabled',
  'pages.contract.status.disabled': 'Disabled',
  'pages.contract.detail.title': 'Contract Document Details',
  'pages.contract.detail.basicInfo': 'Basic Information',
  'pages.contract.detail.fileInfo': 'File Information',
  'pages.contract.detail.timeInfo': 'Time Information',
  'pages.contract.detail.downloadFile': 'Download File',
  'pages.contract.language.chinese': 'Chinese',
  'pages.contract.language.english': 'English',

  // Contract Form
  'pages.contract.form.editTitle': 'Edit Contract Document',
  'pages.contract.form.createTitle': 'Create Contract Document',
  'pages.contract.form.contractInfo': 'Contract Information',
  'pages.contract.form.basicInfo': 'Basic Information',
  'pages.contract.form.fileUpload': 'File Upload',
  'pages.contract.form.docNameLabel': 'Contract Name',
  'pages.contract.form.docNamePlaceholder': 'Please enter contract name',
  'pages.contract.form.docNameRequired': 'Please enter contract name',
  'pages.contract.form.docNameMaxLength': 'Contract name cannot exceed 200 characters',
  'pages.contract.form.descriptionLabel': 'Contract Description',
  'pages.contract.form.descriptionPlaceholder': 'Please enter contract description',
  'pages.contract.form.descriptionMaxLength': 'Contract description cannot exceed 500 characters',
  'pages.contract.form.docTypeLabel': 'File Type',
  'pages.contract.form.docTypePlaceholder': 'Please select file type',
  'pages.contract.form.docTypeRequired': 'Please select file type',
  'pages.contract.form.statusLabel': 'Status',
  'pages.contract.form.statusPlaceholder': 'Please select status',
  'pages.contract.form.statusRequired': 'Please select status',
  'pages.contract.form.statusEnabled': 'Enabled',
  'pages.contract.form.statusDisabled': 'Disabled',
  'pages.contract.form.uploadButton': 'Click to upload file',
  'pages.contract.form.uploading': 'Uploading',
  'pages.contract.form.uploadFileError': 'Only PDF, Word, Excel, PPT or TXT files can be uploaded!',
  'pages.contract.form.uploadSizeError': 'File size cannot exceed 10MB!',
  'pages.contract.form.uploadSuccess': 'File uploaded successfully',
  'pages.contract.form.uploadFailed': 'File upload failed',
  'pages.contract.form.uploadRequired': 'Please upload file',
  'pages.contract.form.fileNameLabel': 'File Name: ',
  'pages.contract.form.fileSizeLabel': 'File Size: ',
  'pages.contract.form.fileTypeLabel': 'File Extension: ',
  'pages.contract.form.downloadOriginal': 'Download Original File',
  'pages.contract.form.updateSuccess': 'Contract document updated successfully',
  'pages.contract.form.createSuccess': 'Contract document created successfully',
  'pages.contract.form.submitFailed': 'Operation failed',

  // Document Template Management Page
  'pages.document.template.title': 'Document Template',
  'pages.document.template.create': 'Add Document',
  'pages.document.template.batchDelete': 'Batch Delete',
  'pages.document.template.confirmDelete': 'Are you sure you want to delete this template?',
  'pages.document.template.confirmBatchDelete': 'Are you sure you want to delete {count} selected templates?',
  'pages.document.template.deleteSuccess': 'Template deleted successfully',
  'pages.document.template.batchDeleteSuccess': 'Templates deleted successfully',
  'pages.document.template.deleteFailed': 'Failed to delete template',
  'pages.document.template.batchDeleteFailed': 'Failed to delete templates',
  'pages.document.template.getListFailed': 'Failed to get template list',
  'pages.document.template.getDetailFailed': 'Failed to get template details',
  'pages.document.template.selectDeleteWarning': 'Please select templates to delete',
  'pages.document.template.columns.name': 'Template Name',
  'pages.document.template.columns.docType': 'Document Type',
  'pages.document.template.columns.mark': 'Document Category',
  'pages.document.template.columns.fileSize': 'File Size',
  'pages.document.template.columns.status': 'Status',
  'pages.document.template.columns.description': 'Description',
  'pages.document.template.columns.createdBy': 'Created By',
  'pages.document.template.columns.createdTime': 'Created Time',
  'pages.document.template.columns.operations': 'Operations',
  'pages.document.template.actions.view': 'View',
  'pages.document.template.actions.edit': 'Edit',
  'pages.document.template.actions.delete': 'Delete',
  'pages.document.template.status.enabled': 'Enabled',
  'pages.document.template.status.disabled': 'Disabled',
  'pages.document.template.detail.title': 'Template Details',
  'pages.document.template.detail.basicInfo': 'Basic Information',
  'pages.document.template.detail.fileInfo': 'File Information',
  'pages.document.template.detail.timeInfo': 'Time Information',
  'pages.document.template.detail.downloadFile': 'Download File',
  'pages.document.template.language.chinese': 'Chinese',
  'pages.document.template.language.english': 'English',

  // Document Template Form
  'pages.document.template.form.editTitle': 'Edit Template',
  'pages.document.template.form.createTitle': 'New Template',
  'pages.document.template.form.documentInfo': 'Template Information',
  'pages.document.template.form.basicInfo': 'Basic Information',
  'pages.document.template.form.fileUpload': 'File Upload',
  'pages.document.template.form.docNameLabel': 'Template Name',
  'pages.document.template.form.docNamePlaceholder': 'Please enter template name',
  'pages.document.template.form.docNameRequired': 'Please enter template name',
  'pages.document.template.form.docNameMaxLength': 'Template name cannot exceed 200 characters',
  'pages.document.template.form.descriptionLabel': 'Template Description',
  'pages.document.template.form.descriptionPlaceholder': 'Please enter template description',
  'pages.document.template.form.descriptionMaxLength': 'Template description cannot exceed 500 characters',
  'pages.document.template.form.docTypeLabel': 'File Type',
  'pages.document.template.form.docTypePlaceholder': 'Please select file type',
  'pages.document.template.form.docTypeRequired': 'Please select file type',
  'pages.document.template.form.markLabel': 'Document Mark',
  'pages.document.template.form.markPlaceholder': 'Please select document mark',
  'pages.document.template.form.markRequired': 'Please select document mark',
  'pages.document.template.form.statusLabel': 'Status',
  'pages.document.template.form.statusPlaceholder': 'Please select status',
  'pages.document.template.form.statusRequired': 'Please select status',
  'pages.document.template.form.statusEnabled': 'Enabled',
  'pages.document.template.form.statusDisabled': 'Disabled',
  'pages.document.template.form.uploadButton': 'Click to upload file',
  'pages.document.template.form.uploading': 'Uploading',
  'pages.document.template.form.uploadFileError': 'Only PDF, Word, Excel, PPT or TXT files can be uploaded!',
  'pages.document.template.form.uploadSizeError': 'File size cannot exceed 10MB!',
  'pages.document.template.form.uploadSuccess': 'File uploaded successfully',
  'pages.document.template.form.uploadFailed': 'File upload failed',
  'pages.document.template.form.uploadRequired': 'Please upload a file',
  'pages.document.template.form.fileNameLabel': 'File Name: ',
  'pages.document.template.form.fileSizeLabel': 'File Size: ',
  'pages.document.template.form.fileTypeLabel': 'File Extension: ',
  'pages.document.template.form.downloadOriginal': 'Download Original File',
  'pages.document.template.form.updateSuccess': 'Template updated successfully',
  'pages.document.template.form.createSuccess': 'Template created successfully',
  'pages.document.template.form.submitFailed': 'Operation failed',

  // Common Documents (File Management) Page
  'pages.document.instruction.title': 'Common Documents',
  'pages.document.instruction.create': 'Add Document',
  'pages.document.instruction.batchDelete': 'Batch Delete',
  'pages.document.instruction.confirmDelete': 'Are you sure you want to delete this common document?',
  'pages.document.instruction.confirmBatchDelete': 'Are you sure you want to delete {count} selected common documents?',
  'pages.document.instruction.deleteSuccess': 'Common document deleted successfully',
  'pages.document.instruction.batchDeleteSuccess': 'Common documents deleted successfully',
  'pages.document.instruction.deleteFailed': 'Failed to delete common document',
  'pages.document.instruction.batchDeleteFailed': 'Failed to delete common documents',
  'pages.document.instruction.getListFailed': 'Failed to get common document list',
  'pages.document.instruction.getDetailFailed': 'Failed to get common document details',
  'pages.document.instruction.selectDeleteWarning': 'Please select common documents to delete',
  'pages.document.instruction.columns.name': 'Document Name',
  'pages.document.instruction.columns.docType': 'Document Type',
  'pages.document.instruction.columns.mark': 'Document Category',
  'pages.document.instruction.columns.fileSize': 'File Size',
  'pages.document.instruction.columns.status': 'Status',
  'pages.document.instruction.columns.description': 'Description',
  'pages.document.instruction.columns.createdBy': 'Created By',
  'pages.document.instruction.columns.createdTime': 'Created Time',
  'pages.document.instruction.columns.operations': 'Operations',
  'pages.document.instruction.actions.view': 'View',
  'pages.document.instruction.actions.edit': 'Edit',
  'pages.document.instruction.actions.delete': 'Delete',
  'pages.document.instruction.status.enabled': 'Enabled',
  'pages.document.instruction.status.disabled': 'Disabled',
  'pages.document.instruction.detail.title': 'Common Document Details',
  'pages.document.instruction.detail.basicInfo': 'Basic Information',
  'pages.document.instruction.detail.fileInfo': 'File Information',
  'pages.document.instruction.detail.timeInfo': 'Time Information',
  'pages.document.instruction.detail.downloadFile': 'Download File',
  'pages.document.instruction.language.chinese': 'Chinese',
  'pages.document.instruction.language.english': 'English',

  // My Documents Page
  'pages.document.my-doc.title': 'My Documents',
  'pages.document.my-doc.pageSubTitlePrivateNote': 'Documents on this page are only visible to you.',
  'pages.document.my-doc.create': 'Add Document',
  'pages.document.my-doc.batchDelete': 'Batch Delete',
  'pages.document.my-doc.confirmDelete': 'Are you sure you want to delete this document?',
  'pages.document.my-doc.confirmBatchDelete': 'Are you sure you want to delete {count} selected documents?',
  'pages.document.my-doc.deleteSuccess': 'Document deleted successfully',
  'pages.document.my-doc.batchDeleteSuccess': 'Documents deleted successfully',
  'pages.document.my-doc.deleteFailed': 'Failed to delete document',
  'pages.document.my-doc.batchDeleteFailed': 'Failed to delete documents',
  'pages.document.my-doc.getListFailed': 'Failed to get document list',
  'pages.document.my-doc.getDetailFailed': 'Failed to get document details',
  'pages.document.my-doc.selectDeleteWarning': 'Please select documents to delete',
  'pages.document.my-doc.columns.name': 'Document Name',
  'pages.document.my-doc.columns.docType': 'Document Type',
  'pages.document.my-doc.columns.mark': 'Document Category',
  'pages.document.my-doc.columns.fileSize': 'File Size',
  'pages.document.my-doc.columns.status': 'Status',
  'pages.document.my-doc.columns.description': 'Description',
  'pages.document.my-doc.columns.createdBy': 'Created By',
  'pages.document.my-doc.columns.createdTime': 'Created Time',
  'pages.document.my-doc.columns.operations': 'Operations',
  'pages.document.my-doc.actions.view': 'View',
  'pages.document.my-doc.actions.edit': 'Edit',
  'pages.document.my-doc.actions.delete': 'Delete',
  'pages.document.my-doc.status.enabled': 'Enabled',
  'pages.document.my-doc.status.disabled': 'Disabled',
  'pages.document.my-doc.detail.title': 'My Document Details',
  'pages.document.my-doc.detail.basicInfo': 'Basic Information',
  'pages.document.my-doc.detail.fileInfo': 'File Information',
  'pages.document.my-doc.detail.timeInfo': 'Time Information',
  'pages.document.my-doc.detail.downloadFile': 'Download File',
  'pages.document.my-doc.language.chinese': 'Chinese',
  'pages.document.my-doc.language.english': 'English',

  // House User Management Page
  'pages.houseUser.title': 'House User Management',
  'pages.houseUser.subTitle': 'Manage owners, tenants and visitors in the community',
  'pages.houseUser.detail.title': 'User Details',
  'pages.houseUser.detail.breadcrumb': 'User Details',

  // House User Detail Page - Tab Labels
  'pages.houseUser.detail.tab.properties': 'User Properties',
  'pages.houseUser.detail.tab.houses': 'Property Information',
  'pages.houseUser.detail.tab.rentInfo': 'Rental Information',
  'pages.houseUser.detail.tab.tenants': 'Tenant Management',
  'pages.houseUser.detail.tab.parking': 'Parking Spaces',
  'pages.houseUser.detail.tab.services': 'Activated Services',
  'pages.houseUser.detail.tab.contacts': 'Emergency Contacts',

  // House User Detail Page - Card Titles
  'pages.houseUser.detail.card.accountInfo': 'Account Information',
  'pages.houseUser.detail.card.basicInfo': 'Basic Information',
  'pages.houseUser.detail.card.contactInfo': 'Contact Information',
  'pages.houseUser.detail.card.residenceInfo': 'Residence Information',
  'pages.houseUser.detail.card.remarks': 'Remarks',
  'pages.houseUser.detail.card.parkingList': 'Parking Space List',

  // House User Detail Page - Label Names
  'pages.houseUser.detail.label.username': 'Username',
  'pages.houseUser.detail.label.role': 'Role',
  'pages.houseUser.detail.label.status': 'Status',
  'pages.houseUser.detail.label.name': 'Name',
  'pages.houseUser.detail.label.gender': 'Gender',
  'pages.houseUser.detail.label.birthDate': 'Date of Birth',
  'pages.houseUser.detail.label.idCard': 'ID Card Number',
  'pages.houseUser.detail.label.phone': 'Phone Number',
  'pages.houseUser.detail.label.email': 'Email Address',
  'pages.houseUser.detail.label.moveInDate': 'Move-in Date',
  'pages.houseUser.detail.label.moveOutDate': 'Move-out Date',
  'pages.houseUser.detail.label.postalCode': 'Postal Code',
  'pages.houseUser.detail.label.address': 'Detailed Address',

  // House User Detail Page - Buttons and Actions
  'pages.houseUser.detail.button.edit': 'Edit',
  'pages.houseUser.detail.button.view': 'View',
  'pages.houseUser.detail.button.addHouse': '+ Add House',
  'pages.houseUser.detail.button.addContact': 'Add Contact',
  'pages.houseUser.detail.button.addTenant': '+ Add Tenant',
  'pages.houseUser.detail.button.unbind': 'Unbind',
  'pages.houseUser.detail.button.delete': 'Delete',

  // House User Detail Page - House Table Columns
  'pages.houseUser.detail.table.house.buildingName': 'Building Name',
  'pages.houseUser.detail.table.house.floor': 'Floor',
  'pages.houseUser.detail.table.house.houseNumber': 'House Number',
  'pages.houseUser.detail.table.house.houseType': 'House Type',
  'pages.houseUser.detail.table.house.area': 'House Area',
  'pages.houseUser.detail.table.house.status': 'House Status',
  'pages.houseUser.detail.table.house.operations': 'Operations',

  // House User Detail Page - Contact Table Columns
  'pages.houseUser.detail.table.contact.contactName': 'Contact Name',
  'pages.houseUser.detail.table.contact.contactPhone': 'Contact Phone',
  'pages.houseUser.detail.table.contact.relationship': 'Relationship to Owner',
  'pages.houseUser.detail.table.contact.remarks': 'Remarks',
  'pages.houseUser.detail.table.contact.createdTime': 'Created Time',
  'pages.houseUser.detail.table.contact.operations': 'Operations',

  // House User Detail Page - Status Labels
  'pages.houseUser.detail.status.enabled': 'Enabled',
  'pages.houseUser.detail.status.disabled': 'Disabled',
  'pages.houseUser.detail.status.other': 'Other',
  'pages.houseUser.detail.status.active': 'Active',
  'pages.houseUser.detail.status.inactive': 'Inactive',
  'pages.houseUser.detail.status.available': 'Available',
  'pages.houseUser.detail.status.sold': 'Sold',
  'pages.houseUser.detail.status.rented': 'Rented',
  'pages.houseUser.detail.status.reserved': 'Reserved',
  'pages.houseUser.detail.status.expired': 'Expired',
  'pages.houseUser.detail.status.pending': 'Pending',
  'pages.houseUser.detail.status.expiring': 'Expiring Soon',
  'pages.houseUser.detail.status.vacant': 'Vacant',
  'pages.houseUser.detail.status.occupied': 'Occupied',
  'pages.houseUser.detail.status.selfOccupied': 'Self-occupied',
  'pages.houseUser.detail.status.underRepair': 'Under Repair',

  // House User Detail Page - Role Labels
  'pages.houseUser.detail.role.owner': 'Owner',
  'pages.houseUser.detail.role.tenant': 'Tenant',
  'pages.houseUser.detail.role.visitor': 'Visitor',

  // House User Detail Page - House Types
  'pages.houseUser.detail.houseType.residential': 'Residential',
  'pages.houseUser.detail.houseType.commercial': 'Commercial',
  'pages.houseUser.detail.houseType.office': 'Office',
  'pages.houseUser.detail.houseType.other': 'Other',

  // House User Detail Page - Parking Types
  'pages.houseUser.detail.parkingType.ground': 'Ground Parking',
  'pages.houseUser.detail.parkingType.underground': 'Underground Parking',
  'pages.houseUser.detail.parkingType.mechanical': 'Mechanical Parking',

  // House User Detail Page - Billing Related
  'pages.houseUser.detail.billingCycle.daily': 'Daily',
  'pages.houseUser.detail.billingCycle.monthly': 'Monthly',
  'pages.houseUser.detail.billingCycle.quarterly': 'Quarterly',
  'pages.houseUser.detail.billingCycle.yearly': 'Yearly',
  'pages.houseUser.detail.billingUnit.month': 'Month',
  'pages.houseUser.detail.billingUnit.day': 'Day',
  'pages.houseUser.detail.billingUnit.year': 'Year',
  'pages.houseUser.detail.billingUnit.unit': 'Unit',
  'pages.houseUser.detail.billingUnit.squareMeter': 'Square Meter',

  // House User Detail Page - Messages
  'pages.houseUser.detail.message.updateSuccess': 'Update successful',
  'pages.houseUser.detail.message.unbindSuccess': 'Unbind successful',
  'pages.houseUser.detail.message.unbindFailed': 'Unbind failed',
  'pages.houseUser.detail.message.deleteHouseSuccess': 'House deleted successfully',
  'pages.houseUser.detail.message.deleteHouseFailed': 'Failed to delete house',
  'pages.houseUser.detail.message.deleteContactSuccess': 'Emergency contact deleted successfully',
  'pages.houseUser.detail.message.deleteContactFailed': 'Failed to delete emergency contact',
  'pages.houseUser.detail.message.loadHousesFailed': 'Failed to load house list',
  'pages.houseUser.detail.message.loadParkingFailed': 'Failed to load parking list',
  'pages.houseUser.detail.message.loadContactsFailed': 'Failed to load emergency contacts',
  'pages.houseUser.detail.message.loadTenantsFailed': 'Failed to load tenant list',
  'pages.houseUser.detail.message.loadRentInfoFailed': 'Failed to load rental information',
  'pages.houseUser.detail.message.loadServicesFailed': 'Failed to load activated services',

  // House User Detail Page - Confirmation Dialogs
  'pages.houseUser.detail.confirm.unbindRent.title': 'Confirm Unbind',
  'pages.houseUser.detail.confirm.unbindRent.content': 'Are you sure you want to terminate this rental relationship?',
  'pages.houseUser.detail.confirm.unbindTenant.title': 'Confirm Unbind',
  'pages.houseUser.detail.confirm.unbindTenant.content': 'Are you sure you want to terminate the binding relationship with this tenant?',
  'pages.houseUser.detail.confirm.deleteContact.title': 'Confirm Delete',
  'pages.houseUser.detail.confirm.deleteContact.content': 'Are you sure you want to delete this emergency contact?',
  'pages.houseUser.detail.confirm.okText': 'OK',
  'pages.houseUser.detail.confirm.cancelText': 'Cancel',

  // House User Detail Page - Empty States
  'pages.houseUser.detail.empty.noHouses': 'No property data available',
  'pages.houseUser.detail.empty.noRentInfo': 'No rental information available',
  'pages.houseUser.detail.empty.noTenants': 'No tenant data available',
  'pages.houseUser.detail.empty.noParking': 'No parking data available',
  'pages.houseUser.detail.empty.noServices': 'No activated services available',
  'pages.houseUser.detail.empty.noContacts': 'No emergency contacts available',

  // House User Detail Page - Other Texts
  'pages.houseUser.detail.loading': 'Loading...',
  'pages.houseUser.detail.locationInfo': 'Location Information',
  'pages.houseUser.detail.structureCode': 'Structure Code',
  'pages.houseUser.detail.parkingType': 'Parking Type',
  'pages.houseUser.detail.startTime': 'Start Time',
  'pages.houseUser.detail.ownerInfo': 'Owner Information',
  'pages.houseUser.detail.tenantName': 'Tenant Name',
  'pages.houseUser.detail.houseInfo': 'House Information',
  'pages.houseUser.detail.monthlyRent': 'Monthly Rent',
  'pages.houseUser.detail.leaseStartDate': 'Lease Start Date',
  'pages.houseUser.detail.leaseEndDate': 'Lease End Date',
  'pages.houseUser.detail.buildingName': 'Building',
  'pages.houseUser.detail.floor': 'Floor',
  'pages.houseUser.detail.houseNumber': 'House Number',
  'pages.houseUser.detail.area': 'Area',
  'pages.houseUser.detail.amount': 'Amount',
  'pages.houseUser.detail.remarks': 'Remarks',
  'pages.houseUser.detail.serviceCount': 'Service Count',
  'pages.houseUser.detail.bindVehicle': 'Vehicle Bound',
  'pages.houseUser.detail.noVehicle': 'No Vehicle Bound',
  'pages.houseUser.detail.brandModel': 'Brand/Model',
  'pages.houseUser.detail.vehicleColor': 'Vehicle Color',
  'pages.houseUser.detail.vehicleType': 'Vehicle Type',
  'pages.houseUser.detail.registrationDate': 'Registration Date',
  'pages.houseUser.detail.bindVehicleButton': '+ Bind Vehicle',
  'pages.houseUser.detail.editVehicleButton': 'Edit',
  'pages.houseUser.detail.daysLeft': 'Expiring soon ({days} days)',

};
